import React, { useEffect, useState } from 'react';
export function ProgressBar() {
  const [width, setWidth] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrolled = scrollTop / docHeight * 100;
      setWidth(scrolled);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="fixed top-[44px] left-0 w-full h-[3px] bg-transparent z-[999]" data-id="element-299">
      <div className="h-full bg-gradient-to-r from-[#2D5A3D] via-[#4A8C5C] to-[#2D5A3D] shadow-[0_0_10px_#2D5A3D]" style={{
      width: `${width}%`,
      transition: 'width 0.1s ease-out'
    }} data-id="element-300" />
    </div>;
}